import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ClareStatus } from "@app/shared/model/clare-status.model";

@Component({
    selector: "clare-status-indicator",
    template: `
        <div class="statusWithIndicator" *ngIf="status; else loadingStatus">
            <div class="circle" [ngStyle]="{ backgroundColor: status[1] }"></div>
            <p>{{ status[0] || "" }}</p>
        </div>

        <ng-template #loadingStatus>
            <span *ngIf="isStatusChanged">
                <clare-spinner text="Fetching status..."></clare-spinner>
            </span>
        </ng-template>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareStatusIndicatorComponent {
    @Input() status: ClareStatus;
    @Input() isStatusChanged = false;
}
